module.exports = __webpack_public_path__ + "static/media/bolso (5).3ef63a63.jpg";